<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <!-- Case Title -->
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" placeholder="Title*" type="text">
      <mat-error *ngIf="inputForm.controls['title'].hasError('required')">
        Title is required!
      </mat-error>
      <mat-error *ngIf="inputForm.controls['title'].hasError('pattern')">
        Title can't contain any of the following characters : \ / : * ? " < > |
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Type of Audit -->
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Type of Audit</mat-label>
      <div class="flex flex-row justify-start items-center">
        <input type="text"
               placeholder="Enter Type of Audit"
               matInput
               formControlName="auditType"
               [matAutocomplete]="audit">
        <mat-autocomplete #audit="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngFor="let auditType of auditTypeFilterdOption|async" [value]="auditType">
            {{ auditType.displayText }}
          </mat-option>
        </mat-autocomplete>
        <!--        <button mat-button class="action-button add-to-fil-btn" [disabled]="!possibleNewAuditType" (click)="onAddAudit()">Add To Audit List</button>-->
        <button *ngIf="inputForm.controls['auditType'].value" mat-icon-button class="icon-dropdown-button close"
                (click)="clearAuditType($event)">
          <i class="fal fa-times"></i>
        </button>
      </div>
      <mat-error *ngIf="inputForm.controls['auditType'].hasError('required')">
        Type of Audit is required!
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Fiscal Years Under Audit -->
  <div>
    <mat-form-field appearance="outline" class="orbitax-date-picker"
                    particleAnalytics
                    analyticsCategory="create-project"
                    analyticsAction="project-tax-year-start"
    >
      <mat-label>Audit Period Start</mat-label>
      <input matInput [matDatepicker]="picker2"
             formControlName="taxYearStart" placeholder="Start Date"
             [min]="minDate"
             [max]="maxDate">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
      <mat-error *ngIf="inputForm.controls['taxYearStart'].hasError('required')">
        Audit Period Start is required!
      </mat-error>
      <mat-error *ngIf="inputForm.controls['taxYearStart'].hasError('hasDateError')">
        Audit Period Start value must be less than ending tax year value.
      </mat-error>
      <mat-error *ngIf="inputForm.controls['taxYearStart'].hasError('hasDateRangeError')">
        Audit Period Start value must be in valid year range.
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Fiscal Years Under Audit -->
  <div>
    <mat-form-field appearance="outline" class="orbitax-date-picker"
                    particleAnalytics
                    analyticsCategory="create-project"
                    analyticsAction="project-tax-year-end"
    >
      <mat-label>Audit Period End</mat-label>
      <input matInput [matDatepicker]="picker1"
             formControlName="taxYearEnd" placeholder="End Date"
             [min]="minDate"
             [max]="maxDate">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
      <mat-error *ngIf="inputForm.controls['taxYearEnd'].hasError('required')">
        Audit Period End is required!
      </mat-error>
      <mat-error *ngIf="inputForm.controls['taxYearEnd'].hasError('hasDateRangeError')">
        Audit Period End value must be in valid year range.
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Country -->
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Countries</mat-label>
      <mat-select multiple formControlName="countries">
        <mat-select-trigger>
          {{countries.value && countries.value?.length > 0 ? countries.value[0].name : ''}}
          <span *ngIf="countries.value?.length > 1" class="additional-selection">
        (+{{countries.value.length - 1}} {{countries.value?.length === 2 ? 'other' : 'others'}})
      </span>
        </mat-select-trigger>
        <mat-option *ngFor="let country of countryList"
                    [value]="country">

          <div class="flex flex-row justify-start items-center">
            <div class="full-grow-no-shrink-no-basis flex flex-row justify-start items-start">
              <div class="text-truncate">{{ country.name }}</div>
              <!--              <div *ngIf="country.hasFootprint" class="m-l-5" matTooltip="" style="color:#337aee; font-weight: 600">*</div>-->
            </div>
            <div class="m-l-20 flex flex-row justify-start items-center">
              <div *ngIf="country.proposedEntityCount>0"
                   class="actual-enitiy flex flex-row justify-start items-center"
                   matTooltip="{{country.actualEntityCount > 0 ? country.actualEntityCount + (country.actualEntityCount > 1 ? ' Actual Entities' : ' Actual Entity') : ''}} {{country.actualEntityCount>0 && country.proposedEntityCount>0 ? '& ' : ''}}{{country.proposedEntityCount > 0 ? country.proposedEntityCount + (country.proposedEntityCount > 1 ? ' Proposed Entities' : ' Proposed Entity') : ''}}">
                <i class="far fa-stop m-r-5"></i>
                <span>{{country.proposedEntityCount}}</span>
              </div>
              <div *ngIf="country.actualEntityCount>0" class="actual-enitiy flex flex-row justify-start items-center"
                   matTooltip="{{country.actualEntityCount > 0 ? country.actualEntityCount + (country.actualEntityCount > 1 ? ' Actual Entities' : ' Actual Entity') : ''}} {{country.actualEntityCount>0 && country.proposedEntityCount>0 ? '& ' : ''}}{{country.proposedEntityCount > 0 ? country.proposedEntityCount + (country.proposedEntityCount > 1 ? ' Proposed Entities' : ' Proposed Entity') : ''}}">
                <i class="far fa-stop m-r-5"></i>
                <span>{{country.actualEntityCount}}</span>
              </div>
            </div>
          </div>
        </mat-option>
      </mat-select>
      <mat-error *ngIf="inputForm.controls['countries'].hasError('required')">
        At least one country need to be selected!
      </mat-error>
    </mat-form-field>
  </div>

  <!--  &lt;!&ndash; Entity &ndash;&gt;-->
  <!--  <div>-->
  <!--    <mat-form-field appearance="outline" fxFlex="100">-->
  <!--      <mat-label>Entities*</mat-label>-->
  <!--      <mat-select multiple formControlName="entity">-->
  <!--        <mat-select-trigger>-->
  <!--          {{entity.value && entity.value?.length > 0 ? entity.value[0].fieldValues['EntityName'] : ''}}-->
  <!--          <span *ngIf="entity.value?.length > 1" class="additional-selection">-->
  <!--        (+{{entity.value.length - 1}} {{entity.value?.length === 2 ? 'other' : 'others'}})-->
  <!--      </span>-->
  <!--        </mat-select-trigger>-->
  <!--        <mat-option *ngFor="let entity of filteredEntities"-->
  <!--                    [value]="entity">-->
  <!--          {{ entity.fieldValues['EntityName'] }}-->
  <!--        </mat-option>-->
  <!--      </mat-select>-->
  <!--      <mat-error *ngIf="inputForm.controls['entity'].hasError('required')">-->
  <!--        At least one entity needs to be selected!-->
  <!--      </mat-error>-->
  <!--    </mat-form-field>-->
  <!--  </div>-->


  <!--  &lt;!&ndash; States &ndash;&gt;-->
  <!--  <div>-->
  <!--    <mat-form-field appearance="outline" fxFlex="100">-->
  <!--      <mat-label>Fed / State / Province or Region</mat-label>-->
  <!--      <div fxLayout="row" fxLayoutAlign="start center">-->
  <!--      <mat-chip-listbox #chipList>-->
  <!--        <mat-chip *ngFor="let state of selectedStateList"-->
  <!--                  [selectable]="true"-->
  <!--                  [removable]="true"-->
  <!--                  (removed)="remove(state)">-->
  <!--          {{ state.stateName }}-->
  <!--          <mat-icon matChipRemove>cancel</mat-icon>-->
  <!--        </mat-chip>-->
  <!--        <input type="text"-->
  <!--               placeholder="Select State"-->
  <!--               matInput-->
  <!--               #stateInput-->
  <!--               formControlName="state"-->
  <!--               [matAutocomplete]="state"-->
  <!--               [matChipInputFor]="chipList"-->
  <!--               [matChipInputAddOnBlur]="false"-->
  <!--               >-->
  <!--      </mat-chip-listbox>-->
  <!--        <button mat-button class="action-button add-to-fil-btn" *ngIf="possibleNewState"  (click)="onAddState()">Add To State List</button>-->
  <!--      </div>-->
  <!--      <mat-autocomplete #state="matAutocomplete" [displayWith]="displayStateFn" (optionSelected)="selected($event)">-->
  <!--        <mat-option *ngFor="let state of stateFilterdOptions|async" [value]="state">-->
  <!--          {{ state.stateName }}-->
  <!--        </mat-option>-->
  <!--      </mat-autocomplete>-->
  <!--&lt;!&ndash;      <div fxLayout="row" fxLayoutAlign="start center">&ndash;&gt;-->
  <!--&lt;!&ndash;        <input type="text"&ndash;&gt;-->
  <!--&lt;!&ndash;               placeholder="Select State"&ndash;&gt;-->
  <!--&lt;!&ndash;               matInput&ndash;&gt;-->
  <!--&lt;!&ndash;               formControlName="state"&ndash;&gt;-->
  <!--&lt;!&ndash;               [matAutocomplete]="state">&ndash;&gt;-->
  <!--&lt;!&ndash;        <mat-autocomplete #state="matAutocomplete" [displayWith]="displayStateFn">&ndash;&gt;-->
  <!--&lt;!&ndash;          <mat-option *ngFor="let state of stateFilterdOptions|async" [value]="state">&ndash;&gt;-->
  <!--&lt;!&ndash;            {{ state.stateName }}&ndash;&gt;-->
  <!--&lt;!&ndash;          </mat-option>&ndash;&gt;-->
  <!--&lt;!&ndash;        </mat-autocomplete>&ndash;&gt;-->
  <!--&lt;!&ndash;        <button mat-button class="action-button add-to-fil-btn" *ngIf="possibleNewState"  (click)="onAddState()">Add To State List</button>&ndash;&gt;-->
  <!--&lt;!&ndash;      </div>&ndash;&gt;-->
  <!--&lt;!&ndash;      <mat-select formControlName="state" [disabled]="!isStateAvailable">&ndash;&gt;-->
  <!--&lt;!&ndash;        <mat-option *ngFor="let state of stateList" [value]="state">&ndash;&gt;-->
  <!--&lt;!&ndash;          {{ state.stateName }}&ndash;&gt;-->
  <!--&lt;!&ndash;        </mat-option>&ndash;&gt;-->
  <!--&lt;!&ndash;      </mat-select>&ndash;&gt;-->
  <!--    </mat-form-field>-->
  <!--  </div>-->

  <!--  &lt;!&ndash; Local/ Municipal &ndash;&gt;-->
  <!--  <div>-->
  <!--    <mat-form-field appearance="outline" fxFlex="100">-->
  <!--      <mat-label>Local/Municipal </mat-label>-->
  <!--      <input formControlName="local" matInput placeholder="Local/Municipal" type="text">-->
  <!--    </mat-form-field>-->
  <!--  </div>-->

  <!--  &lt;!&ndash; Other gov’t jurisdiction &ndash;&gt;-->
  <!--  <div>-->
  <!--    <mat-form-field appearance="outline" fxFlex="100">-->
  <!--      <mat-label>Other Gov’t Jurisdiction</mat-label>-->
  <!--      <input formControlName="other" matInput placeholder="Other gov’t jurisdiction" type="text">-->
  <!--    </mat-form-field>-->
  <!--  </div>-->

  <!-- Reference -->
  <!--  <div>-->
  <!--    <mat-form-field appearance="outline" fxFlex="100">-->
  <!--      <mat-label>Reference*</mat-label>-->
  <!--      <input formControlName="references" matInput placeholder="Reference*" type="text">-->
  <!--      <mat-error *ngIf="inputForm.controls['reference'].hasError('required')">-->
  <!--        References is required!-->
  <!--      </mat-error>-->
  <!--    </mat-form-field>-->
  <!--  </div>-->

  <!-- Description -->
  <!--  <div>-->
  <!--    <mat-form-field appearance="outline" fxFlex="100">-->
  <!--      <mat-label>Description</mat-label>-->
  <!--      <textarea matInput formControlName="description" placeholder="Description (Optional)" type="text" rows="5">-->
  <!--      </textarea>-->
  <!--    </mat-form-field>-->
  <!--  </div>-->

</form>
